module.exports = __webpack_public_path__ + "static/media/livestream.aaee7723.svg";